import { z } from '@hono/zod-openapi'

export const PLAN_MASTER_ID_STANDARD = '1'
export const PLAN_MASTER_ID_PLUS = '2'
/**
 * Echoes 経由オーナー専用プラン。AgentCall 側では課金せず Echoes が請求する(要件 F-11)。
 * Echoes 外部連携 API の Tenant.plan_id(1: フルプラン / 2: コールセンターのみ)に 1 対 1 で対応する。
 */
export const PLAN_MASTER_ID_ECHOES_FULL = '3'
export const PLAN_MASTER_ID_ECHOES_CALL_CENTER = '4'
export const ECHOES_PLAN_MASTER_IDS: readonly string[] = [
  PLAN_MASTER_ID_ECHOES_FULL,
  PLAN_MASTER_ID_ECHOES_CALL_CENTER,
]
export const isEchoesPlanMasterId = (planMasterId: string): boolean =>
  ECHOES_PLAN_MASTER_IDS.includes(planMasterId)
export const PLAN_MASTER_IDs = [
  { id: PLAN_MASTER_ID_STANDARD, value: 'スタンダードプラン' },
  { id: PLAN_MASTER_ID_PLUS, value: 'プラスプラン' },
  { id: PLAN_MASTER_ID_ECHOES_FULL, value: 'エコーズフルプラン' },
  {
    id: PLAN_MASTER_ID_ECHOES_CALL_CENTER,
    value: 'エコーズコールセンタープラン',
  },
] as const
export const idZ = z
  .enum([
    PLAN_MASTER_ID_STANDARD,
    PLAN_MASTER_ID_PLUS,
    PLAN_MASTER_ID_ECHOES_FULL,
    PLAN_MASTER_ID_ECHOES_CALL_CENTER,
  ])
  .openapi({
    description:
      'プランマスタID（1:スタンダードプラン / 2:プラスプラン / 3:エコーズフルプラン / 4:エコーズコールセンタープラン）',
    example: PLAN_MASTER_ID_STANDARD,
  })
export type id = z.infer<typeof idZ>

export const nameZ = z
  .string()
  .openapi({ description: 'プラン名', example: 'name' })
export type name = z.infer<typeof nameZ>

export const monthlyPriceZ = z
  .number()
  .openapi({ description: '月額料金（円・税抜）', example: 1000 })
export type monthlyPrice = z.infer<typeof monthlyPriceZ>

export const descriptionZ = z
  .string()
  .openapi({ description: 'プランの説明文', example: 'description' })
export type description = z.infer<typeof descriptionZ>

export const isActiveZ = z
  .boolean()
  .openapi({ description: '現在申し込み可能なプランかどうか', example: true })
export type isActive = z.infer<typeof isActiveZ>
